import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { FamilyFestCreateVehicleAsync, FamilyFestUpdateVehicleAsync, FamilyFestDeleteVehicleAsync, FamilyFestGetVehiclesByPickupIdAsync, FamilyFestGetVehiclesPaginatedAsync, getFamilyFestVehicleByIdAsync } from './familyFestPickupLocationVehicleThunk';
const initialState = {
    status: APIStatus.IDLE,
    familyFestVehicles: [],
    familyFestVehiclesPaginated: null,
    familyFestVehicle: undefined
};
export const familyFestPickupLocationVehicleSlice = createSlice({
    name: 'familyFestPickupLocationVehicle',
    initialState,
    reducers: {
        resetFamilyFestVehicleStatus: (state) => {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(FamilyFestGetVehiclesByPickupIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(FamilyFestGetVehiclesByPickupIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.familyFestVehicles = action.payload;
        })
            .addCase(FamilyFestGetVehiclesByPickupIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(FamilyFestCreateVehicleAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(FamilyFestCreateVehicleAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.familyFestVehicle = action.payload;
        })
            .addCase(FamilyFestCreateVehicleAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(FamilyFestUpdateVehicleAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(FamilyFestUpdateVehicleAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.familyFestVehicle = action.payload;
        })
            .addCase(FamilyFestUpdateVehicleAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(FamilyFestDeleteVehicleAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(FamilyFestDeleteVehicleAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(FamilyFestDeleteVehicleAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(FamilyFestGetVehiclesPaginatedAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(FamilyFestGetVehiclesPaginatedAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            const payload = action.payload;
            state.familyFestVehiclesPaginated = payload;
            state.familyFestVehicles = payload.items;
        })
            .addCase(FamilyFestGetVehiclesPaginatedAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFamilyFestVehicleByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFamilyFestVehicleByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.familyFestVehicle = action.payload;
        })
            .addCase(getFamilyFestVehicleByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { resetFamilyFestVehicleStatus } = familyFestPickupLocationVehicleSlice.actions;
export default familyFestPickupLocationVehicleSlice.reducer;
